<div class="saloons-list-page">
  <header class="page-header">
    <div class="header-content">
      <h1>Liste des saloons</h1>
      <p class="subtitle">Gérez tous les établissements</p>
    </div>
    <a routerLink="/dashboard/create-saloon" class="btn-add">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
      </svg>
      Nouveau saloon
    </a>
  </header>

  <!-- Filters - Always visible -->
  <div class="list-filters">
    <div class="filter-item">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M11 5h10M11 9h7M11 13h4M3 17l3 3 3-3M6 18V4" />
      </svg>
      <select [ngModel]="sortOption()" (ngModelChange)="onSortChange($event)">
        <option value="name-asc">Alphabétique</option>
        <option value="name-desc">Alphabétique inversé</option>
        <option value="connected-desc">Plus de connectés</option>
        <option value="connected-asc">Moins de connectés</option>
      </select>
    </div>
    <div class="search-box">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="M21 21l-4.35-4.35" />
      </svg>
      <input
        type="text"
        placeholder="Rechercher par nom de saloon..."
        [value]="searchQuery()"
        (input)="onSearchChange($any($event.target).value)"
      />
      @if (searchQuery()) {
      <button type="button" class="clear-search" (click)="clearSearch()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
      }
    </div>
  </div>

  @if (isLoading) {
  <div class="loading">
    <div class="spinner"></div>
    <p>Chargement des saloons...</p>
  </div>
  } @else if (error) {
  <div class="error-message">
    <p>{{ error }}</p>
    <button type="button" (click)="loadSaloons()">Réessayer</button>
  </div>
  } @else if (saloons().length === 0) {
  <div class="empty-state">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1"
    >
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
    @if (searchQuery()) {
    <h3>Aucun résultat</h3>
    <p>Aucun saloon ne correspond à "{{ searchQuery() }}"</p>
    } @else {
    <h3>Aucun saloon</h3>
    <p>Commencez par créer votre premier établissement</p>
    }
  </div>
  } @else {
  <!-- Desktop Table View -->
  <div class="saloons-table-wrapper">
    <table class="saloons-table">
      <thead>
        <tr>
          <th>Image</th>
          <th>Nom</th>
          <th>Type</th>
          <th>Ville</th>
          <th>Adresse</th>
          <th>Coordonnées</th>
          <th>Connectés</th>
          <th>Privé</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (saloon of saloons(); track saloon.id) {
        <tr>
          <td class="cell-image">
            <img [src]="saloon.imgUrl" [alt]="saloon.name" loading="lazy" />
          </td>
          <td class="cell-name">{{ saloon.name }}</td>
          <td class="cell-type">
            <span class="type-badge">{{ getTypeLabel(saloon.type) }}</span>
          </td>
          <td>{{ saloon.city || '-' }}</td>
          <td class="cell-address">{{ saloon.address || '-' }}</td>
          <td class="cell-coords">
            <span class="coord"
              >{{ saloon.latitude?.toFixed(4) }}, {{ saloon.longitude?.toFixed(4) }}</span
            >
          </td>
          <td class="cell-connected">
            <span
              class="connected-badge"
              [class.has-users]="saloon.connectedCount && saloon.connectedCount > 0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
              {{ saloon.connectedCount || 0 }}
            </span>
          </td>
          <td class="cell-private">
            <button
              type="button"
              class="privacy-badge"
              [class.private]="saloon.isPrivate === true"
              [class.public]="saloon.isPrivate !== true"
              (click)="togglePrivate(saloon)"
            >
              {{ saloon.isPrivate === true ? 'Privé' : 'Public' }}
            </button>
          </td>
          <td class="cell-status">
            <button
              type="button"
              class="status-badge"
              [class.active]="saloon.isActive !== false"
              [class.inactive]="saloon.isActive === false"
              (click)="toggleActive(saloon)"
            >
              {{ saloon.isActive !== false ? 'Actif' : 'Inactif' }}
            </button>
          </td>
          <td class="cell-actions">
            <button
              type="button"
              class="btn-action"
              [class.pause]="saloon.isActive !== false"
              [class.play]="saloon.isActive === false"
              (click)="toggleActive(saloon)"
              [title]="saloon.isActive !== false ? 'Mettre en pause' : 'Activer'"
            >
              @if (saloon.isActive !== false) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <rect x="6" y="4" width="4" height="16" />
                <rect x="14" y="4" width="4" height="16" />
              </svg>
              } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="2"
              >
                <polygon points="5 3 19 12 5 21 5 3" />
              </svg>
              }
            </button>
            <button
              type="button"
              class="btn-action view"
              (click)="openSaloonStats(saloon)"
              title="Voir les statistiques"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>
            <button
              type="button"
              class="btn-action edit"
              [routerLink]="['/dashboard/edit-saloon', saloon.id]"
              title="Modifier"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </button>
            <button
              type="button"
              class="btn-action delete"
              (click)="confirmDeleteSaloon(saloon)"
              title="Supprimer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="3 6 5 6 21 6" />
                <path
                  d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                />
              </svg>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Pagination Controls -->
  <div class="pagination-wrapper">
    <div class="pagination-left">
      <span class="pagination-info">
        {{ (currentPage() - 1) * itemsPerPage() + 1 }}-{{
          currentPage() * itemsPerPage() > totalElements()
            ? totalElements()
            : currentPage() * itemsPerPage()
        }}
        sur {{ totalElements() }}
      </span>
    </div>
    <div class="pagination-center">
      <button
        type="button"
        class="pagination-btn"
        [disabled]="currentPage() === 1"
        (click)="previousPage()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <div class="pagination-pages">
        @for (page of [].constructor(totalPages()); track $index) {
        <button
          type="button"
          class="page-number"
          [class.active]="currentPage() === $index + 1"
          (click)="goToPage($index + 1)"
        >
          {{ $index + 1 }}
        </button>
        }
      </div>
      <button
        type="button"
        class="pagination-btn"
        [disabled]="currentPage() === totalPages()"
        (click)="nextPage()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
    <div class="pagination-right">
      <select [ngModel]="itemsPerPage()" (ngModelChange)="onItemsPerPageChange($event)">
        <option [ngValue]="10">10 / page</option>
        <option [ngValue]="25">25 / page</option>
        <option [ngValue]="50">50 / page</option>
        <option [ngValue]="100">100 / page</option>
      </select>
    </div>
  </div>

  <!-- Mobile Cards View -->
  <div class="saloons-mobile-cards">
    @for (saloon of saloons(); track saloon.id) {
    <div class="saloon-card" [class.expanded]="isSaloonExpanded(saloon.id)">
      <button type="button" class="saloon-card-header" (click)="toggleSaloonExpand(saloon.id)">
        <img [src]="saloon.imgUrl" [alt]="saloon.name" class="saloon-image" loading="lazy" />
        <div class="saloon-main-info">
          <span class="saloon-name">{{ saloon.name }}</span>
          <span class="saloon-type-badge-small">{{ getTypeLabel(saloon.type) }}</span>
          <span class="saloon-city">{{ saloon.city || 'Ville non renseignée' }}</span>
        </div>
        <div class="expand-indicator">
          <span
            class="connected-count"
            [class.has-users]="saloon.connectedCount && saloon.connectedCount > 0"
          >
            {{ saloon.connectedCount || 0 }}
          </span>
          <svg
            class="chevron-icon"
            [class.rotated]="isSaloonExpanded(saloon.id)"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </button>
      @if (isSaloonExpanded(saloon.id)) {
      <div class="saloon-card-body">
        @if (saloon.address) {
        <p class="saloon-address">📍 {{ saloon.address }}</p>
        }
        <div class="saloon-badges">
          <span
            class="connected-badge"
            [class.has-users]="saloon.connectedCount && saloon.connectedCount > 0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
            </svg>
            {{ saloon.connectedCount || 0 }} en ligne
          </span>
          <button
            type="button"
            class="privacy-badge"
            [class.private]="saloon.isPrivate === true"
            [class.public]="saloon.isPrivate !== true"
            (click)="togglePrivate(saloon); $event.stopPropagation()"
          >
            {{ saloon.isPrivate === true ? 'Privé' : 'Public' }}
          </button>
          <button
            type="button"
            class="status-badge"
            [class.active]="saloon.isActive !== false"
            [class.inactive]="saloon.isActive === false"
            (click)="toggleActive(saloon); $event.stopPropagation()"
          >
            {{ saloon.isActive !== false ? 'Actif' : 'Inactif' }}
          </button>
        </div>
      </div>
      <div class="saloon-card-actions">
        <button
          type="button"
          class="btn-action-mobile"
          [class.pause]="saloon.isActive !== false"
          [class.play]="saloon.isActive === false"
          (click)="toggleActive(saloon)"
        >
          @if (saloon.isActive !== false) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <rect x="6" y="4" width="4" height="16" />
            <rect x="14" y="4" width="4" height="16" />
          </svg>
          Pause } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
          >
            <polygon points="5 3 19 12 5 21 5 3" />
          </svg>
          Activer }
        </button>
        <button type="button" class="btn-action-mobile view" (click)="openSaloonStats(saloon)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          Participants
        </button>
        <a class="btn-action-mobile edit" [routerLink]="['/dashboard/edit-saloon', saloon.id]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
          </svg>
          Modifier
        </a>
        <button
          type="button"
          class="btn-action-mobile delete"
          (click)="confirmDeleteSaloon(saloon)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polyline points="3 6 5 6 21 6" />
            <path
              d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
            />
          </svg>
          Supprimer
        </button>
      </div>
      }
    </div>
    }
  </div>

  <!-- Modal pour afficher les utilisateurs -->
  @if (showUsersModal && selectedSaloon) {
  <div
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
    (click)="closeModal()"
    (keyup.escape)="closeModal()"
  >
    <div
      class="modal-content"
      role="document"
      (click)="$event.stopPropagation()"
      (keyup.escape)="closeModal()"
    >
      <div class="modal-header">
        <h3>Participants - {{ selectedSaloon.name }}</h3>
        <button type="button" class="close-btn" (click)="closeModal()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        @if (loadingUsers) {
        <div class="loading-users">
          <div class="spinner"></div>
          <p>Chargement...</p>
        </div>
        } @else if (saloonUsers.length === 0) {
        <div class="empty-users">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <line x1="17" y1="8" x2="23" y2="8" />
          </svg>
          <p>Aucun participant actuellement</p>
        </div>
        } @else {
        <div class="users-list">
          @for (user of saloonUsers; track user.id) {
          <div class="user-item">
            <img
              [src]="
                (user.imgUrl | versionedImageUrl : user.profileImageUpdatedAt) ||
                'assets/default-avatar.png'
              "
              [alt]="user.userName"
              class="user-avatar"
              loading="lazy"
            />
            <div class="user-info">
              <span class="user-name">{{ user.userName || user.firstname }}</span>
              <span class="user-city">{{ user.city || 'Ville non renseignée' }}</span>
            </div>
            @if (user.age) {
            <span class="user-age">{{ user.age }} ans</span>
            }
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
  }

  <!-- Modal de confirmation de suppression -->
  @if (showDeleteModal() && saloonToDelete()) {
  <div
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
    (click)="closeDeleteModal()"
    (keyup.escape)="closeDeleteModal()"
  >
    <div
      class="modal-content delete-modal"
      role="document"
      (click)="$event.stopPropagation()"
      (keyup.escape)="closeDeleteModal()"
    >
      <div class="modal-header danger">
        <h3>Confirmer la suppression</h3>
        <button type="button" class="close-btn" (click)="closeDeleteModal()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="warning-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
            />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <p class="warning-text">
          Êtes-vous sûr de vouloir supprimer le saloon
          <strong>{{ saloonToDelete()!.name }}</strong> ?
        </p>
        <p class="warning-subtext">Cette action est irréversible.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="closeDeleteModal()">Annuler</button>
        <button type="button" class="btn-delete" (click)="deleteSaloon()" [disabled]="deleting()">
          @if (deleting()) {
          <span class="spinner-small"></span>
          Suppression... } @else { Supprimer }
        </button>
      </div>
    </div>
  </div>
  } }
</div>
